import { Controller } from "@hotwired/stimulus"

// Live UTC clock for the Savant topbar.
export default class extends Controller {
  static targets = ["time"]

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const now = new Date()
    const pad = (n) => String(n).padStart(2, "0")
    this.timeTarget.textContent =
      `${pad(now.getUTCHours())}:${pad(now.getUTCMinutes())}:${pad(now.getUTCSeconds())}`
  }
}
